import { Navigate } from 'react-router-dom'
import { CustomerDetailFragment, CustomerType } from 'src/api/api.generated'
import { FormLayoutAppearance } from 'src/app/layout/form-layout/form-layout.types'
import CompanyForm from './company/company.form'
import { CustomerFormData, FocusedField } from './customer.form.types'
import PersonForm from './person/person.form'

export type CustomerFormProps = {
  loading: boolean
  customer: CustomerDetailFragment | null
  onSubmit: (data: CustomerFormData) => Promise<void>
  appearance: FormLayoutAppearance
  title: string
  customerType?: CustomerType
  onCancel: () => void
  focusedField?: FocusedField
}

export default function CustomerForm(props: CustomerFormProps) {
  const { loading, customer, onSubmit, appearance, title, customerType, onCancel, focusedField } = props
  const type = customer?.type || customerType || CustomerType.PERSON

  switch (type) {
    case CustomerType.PERSON:
      return (
        <PersonForm //
          appearance={appearance}
          title={title}
          loading={loading}
          onSubmit={onSubmit}
          customer={customer}
          onCancel={onCancel}
          focusedField={focusedField}
        />
      )
    case CustomerType.COMPANY:
      return (
        <CompanyForm //
          appearance={appearance}
          title={title}
          loading={loading}
          onSubmit={onSubmit}
          customer={customer}
          onCancel={onCancel}
          focusedField={focusedField}
        />
      )
    default:
      return <Navigate to="*" />
  }
}
